import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { CheckCircle, Home, FileText } from "lucide-react";

const LOGO_HORIZONTAL = "https://customer-assets.emergentagent.com/job_4aa3e30f-645a-43e8-83ed-b83576a14c9f/artifacts/p43xkrnl_SusTek%20Colored%20Logo%20Name%20-%20Horizontal.svg";

const SubmissionConfirmation = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-cream to-white flex flex-col">
      {/* Header */}
      <header className="glass-header sticky top-0 z-50" data-testid="confirmation-header">
        <div className="container-main py-4 flex items-center">
          <Link to="/" className="flex items-center gap-2" data-testid="confirmation-logo">
            <img src={LOGO_HORIZONTAL} alt="SusTek" className="h-10" />
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center py-12 px-4">
        <Card className="w-full max-w-lg border-border/50 shadow-lg animate-fade-in" data-testid="confirmation-card">
          <CardHeader className="text-center">
            <div className="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <CheckCircle className="w-10 h-10 text-emerald-600" />
            </div>
            <CardTitle className="font-heading text-3xl text-foreground">
              Submission Complete!
            </CardTitle>
            <CardDescription className="text-base">
              Thank you for completing the ESG questionnaire
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="bg-cream p-6 rounded-xl">
              <h3 className="font-heading text-lg font-semibold text-foreground mb-3">
                What happens next?
              </h3>
              <ul className="space-y-3">
                <li className="flex items-start gap-3 text-muted-foreground">
                  <span className="w-6 h-6 bg-forest text-white rounded-full flex items-center justify-center text-sm flex-shrink-0">1</span>
                  <span>Our sustainability team will review your responses</span>
                </li>
                <li className="flex items-start gap-3 text-muted-foreground">
                  <span className="w-6 h-6 bg-forest text-white rounded-full flex items-center justify-center text-sm flex-shrink-0">2</span>
                  <span>You may be contacted for clarification if needed</span>
                </li>
                <li className="flex items-start gap-3 text-muted-foreground">
                  <span className="w-6 h-6 bg-forest text-white rounded-full flex items-center justify-center text-sm flex-shrink-0">3</span>
                  <span>Your ESG profile will be incorporated into our supply chain assessment</span>
                </li>
              </ul>
            </div>

            <div className="bg-sage/10 p-4 rounded-lg border border-sage/20">
              <div className="flex items-start gap-3">
                <FileText className="w-5 h-5 text-sage flex-shrink-0 mt-0.5" />
                <div>
                  <p className="text-sm font-medium text-foreground">Your data is secure</p>
                  <p className="text-sm text-muted-foreground">
                    All information is handled in accordance with our data privacy policy and GDPR requirements.
                  </p>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <Link to="/" className="flex-1">
                <Button className="w-full btn-primary flex items-center justify-center gap-2" data-testid="confirmation-home-btn">
                  <Home className="w-4 h-4" />
                  Return Home
                </Button>
              </Link>
              <Link to="/questionnaire" className="flex-1">
                <Button variant="outline" className="w-full btn-outline flex items-center justify-center gap-2" data-testid="confirmation-view-btn">
                  <FileText className="w-4 h-4" />
                  View Submission
                </Button>
              </Link>
            </div>
          </CardContent>
        </Card>
      </main>

      {/* Footer */}
      <footer className="py-6 border-t border-border bg-cream">
        <div className="container-main text-center text-sm text-muted-foreground">
          <p>&copy; {new Date().getFullYear()} SusTek Sustainable Supply Chain Portal. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default SubmissionConfirmation;
